import { Offcanvas, Form, Row, Col, InputGroup, Button } from 'react-bootstrap';
import Select from 'react-select';

const FilterClientOffcanvas = ({ 
    show, 
    onHide,
    clientFilter,
    setClientFilter,
    projectFilter,
    setProjectFilter,
    emailFilter,
    setEmailFilter,
    phoneFilter,
    setPhoneFilter,
    budgetRange,
    setBudgetRange,
    stageFilter,
    setStageFilter,
    projectOptions,
    emailOptions,
    phoneOptions,
    clientOptions,
    stageOptions
}) => {
    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header className='px-4 py-3' closeButton>
                <Offcanvas.Title className='display-1'>Filter Projects</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className='px-4 py-3'>
                <Form>
                    <Row className='gy-2'>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Client Name</Form.Label>
                                <Select
                                    value={clientFilter}
                                    onChange={setClientFilter}
                                    options={clientOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Project</Form.Label>
                                <Select
                                    value={projectFilter}
                                    onChange={setProjectFilter}
                                    options={projectOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Email ID</Form.Label>
                                <Select
                                    value={emailFilter}
                                    onChange={setEmailFilter}
                                    options={emailOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select email addresses"
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Phone Number</Form.Label>
                                <Select
                                    value={phoneFilter}
                                    onChange={setPhoneFilter}
                                    options={phoneOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select phone numbers"
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Budget Range</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        type="number"
                                        value={budgetRange[0] || ''}
                                        onChange={(e) => setBudgetRange([e.target.value ? Number(e.target.value) : null, budgetRange[1]])}
                                        placeholder="Min budget"
                                        min={0}
                                    />
                                    <InputGroup.Text className="bg-light">to</InputGroup.Text>
                                    <Form.Control
                                        type="number"
                                        value={budgetRange[1] || ''}
                                        onChange={(e) => setBudgetRange([budgetRange[0], e.target.value ? Number(e.target.value) : null])}
                                        placeholder="Max budget"
                                        min={budgetRange[0] || 0}
                                    />
                                </InputGroup>
                            </Form.Group>
                        </Col>

                        <Col sm={12}>
                            <Form.Group>
                                <Form.Label>Stage</Form.Label>
                                <Select
                                    value={stageFilter}
                                    onChange={setStageFilter}
                                    options={stageOptions}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder=""
                                    isClearable
                                    isMulti
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Offcanvas.Body>
            <div className="p-3 border-top">
                <div className="d-flex justify-content-between">
                    <Button variant="link" className='text-decoration-none' onClick={() => {
                        setClientFilter(null);
                        setProjectFilter(null);
                        setEmailFilter(null);
                        setPhoneFilter(null);
                        setBudgetRange([null, null]);
                        setStageFilter(null);
                    }}>
                        Reset
                    </Button>
                    <Button variant="primary" onClick={onHide}>
                        Apply Filters
                    </Button>
                </div>
            </div>
        </Offcanvas>
    );
};

export default FilterClientOffcanvas;
